import React, { useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCw, CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";
import { useOnlineStatus, useSyncState } from "@/hooks/useConnection";
import { manualSync } from "@/lib/offlineApi";
import { toast } from "sonner";

export function ConnectionPill() {
    const online = useOnlineStatus();
    return (
        <span
            className={`pill ${online ? "pill-completed" : "pill-not_done"}`}
            data-testid="connection-pill"
            title={online ? "En línea" : "Sin conexión"}
        >
            {online ? <Wifi className="w-3 h-3" /> : <WifiOff className="w-3 h-3" />}
            {online ? "En línea" : "Sin conexión"}
        </span>
    );
}

export function SyncBadge() {
    const online = useOnlineStatus();
    const state = useSyncState();
    const [busy, setBusy] = useState(false);

    const handleSync = async () => {
        if (!online) return toast.warning("Sin conexión. Reintentará automáticamente al recuperarla.");
        if (state.total === 0) return toast.info("No hay operaciones pendientes");
        setBusy(true);
        try {
            await manualSync();
            toast.success("Sincronización completada");
        } finally {
            setBusy(false);
        }
    };

    if (state.total === 0) return null;

    const hasErrors = state.error > 0;

    return (
        <button
            onClick={handleSync}
            className={`pill ${hasErrors ? "pill-not_done" : "pill-in_progress"} hover:opacity-90 cursor-pointer`}
            data-testid="sync-badge"
            title="Tocar para sincronizar ahora"
        >
            {busy || state.syncing > 0 ? <Loader2 className="w-3 h-3 animate-spin" /> : hasErrors ? <AlertTriangle className="w-3 h-3" /> : <RefreshCw className="w-3 h-3" />}
            <span>{state.total} pendiente{state.total === 1 ? "" : "s"}</span>
        </button>
    );
}

/** Tiny chip used per service card when it has a pending operation. */
export function PendingSyncChip({ className = "" }) {
    return (
        <span className={`pill pill-in_progress ${className}`} data-testid="pending-sync-chip" title="Cambios locales pendientes de sincronizar">
            <RefreshCw className="w-3 h-3" />
            Sincronizando...
        </span>
    );
}
